export default {
  namespaced: true,
  state: {
    SCROLL_TOP: 0,
    SCROLL_TO_BOTTOM: 0,
    SCROLL_ING: false
  },
  mutations: {
    SET_SCROLL_VAL (state, {SCROLL_TOP, SCROLL_TO_BOTTOM}) {
      state.SCROLL_TOP = SCROLL_TOP
      state.SCROLL_TO_BOTTOM = SCROLL_TO_BOTTOM
    },
    SET_SCROLL_ING (state, val) {
      state.SCROLL_ING = val
    }
  }
}
